import { render, staticRenderFns } from "./cms-block-list-item.vue?vue&type=template&id=201373a0&scoped=true"
import script from "./cms-block-list-item.vue?vue&type=script&lang=js"
export * from "./cms-block-list-item.vue?vue&type=script&lang=js"
import style0 from "./cms-block-list-item.vue?vue&type=style&index=0&id=201373a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201373a0",
  null
  
)

export default component.exports